export default "__VITE_ASSET__0c3ec5a3__"